module.exports = __webpack_public_path__ + "img/illus_empty.ee947351.png";